import { render, staticRenderFns } from "./CurrentDissSovet.vue?vue&type=template&id=30d62475&scoped=true"
import script from "./CurrentDissSovet.vue?vue&type=script&lang=js"
export * from "./CurrentDissSovet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30d62475",
  null
  
)

export default component.exports